(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('.header_main_navigation_desktop .nativity-story-disclosure').forEach((root) => {
      if (root.dataset.disclosureReady) return;
      const toggle = root.querySelector('.nativity-story-toggle');
      const submenu = root.querySelector(':scope > .child_main');
      if (!toggle || !submenu) return;
      root.dataset.disclosureReady = 'true';
      let leaveTimer;
      let suppressHover = false;
      const inControl = (node) => node instanceof Node && (toggle.contains(node) || submenu.contains(node));
      const setOpen = (open) => {
        clearTimeout(leaveTimer);
        submenu.hidden = !open;
        submenu.classList.remove('active');
        root.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
      };
      const closeSoon = (event) => {
        if (inControl(event.relatedTarget)) return;
        leaveTimer = setTimeout(() => setOpen(false), 120);
      };
      toggle.addEventListener('pointerenter', (event) => {
        clearTimeout(leaveTimer);
        if (event.pointerType !== 'touch' && !suppressHover) setOpen(true);
      });
      toggle.addEventListener('pointerleave', (event) => {
        suppressHover = false;
        closeSoon(event);
      });
      submenu.addEventListener('pointerenter', () => clearTimeout(leaveTimer));
      submenu.addEventListener('pointerleave', closeSoon);
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        suppressHover = !open && toggle.matches(':hover');
        setOpen(open);
      });
      toggle.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        event.preventDefault();
        setOpen(true);
        const links = submenu.querySelectorAll('a[href]');
        const target = event.key === 'ArrowUp' ? links[links.length - 1] : links[0];
        target?.focus();
      });
      root.addEventListener('focusout', () => {
        setTimeout(() => {
          if (!inControl(document.activeElement)) setOpen(false);
        }, 0);
      });
      document.addEventListener('click', (event) => {
        if (!inControl(event.target)) setOpen(false);
      });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || toggle.getAttribute('aria-expanded') !== 'true') return;
        const restoreFocus = inControl(document.activeElement);
        suppressHover = toggle.matches(':hover');
        setOpen(false);
        if (restoreFocus) {
          event.preventDefault();
          toggle.focus();
        }
      });
      setOpen(false);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
